@for (menuItem of menuItems(); track menuItem) {
  <soft-menu-item [menuItem]="menuItem" class="w-full"></soft-menu-item>
}
